
const DigitalcoinUtil = (() => {
    const conf = {
        EB: ['EBpay_WD', /^eb[a-z0-9]{32}$/, 34, '以 “eb” 开头，为一串 34 个字母与数字组成', 'EBpay', 'EB'],
        C_988: ['C_988pay_WD', /^[um][a-z0-9]{31}$/, 32, '以 “u” 或 “m” 开头，为一串 32 个字母与数字组成', '988钱包','988 币'],
        C_808: ['C_808pay_WD', /^[a-zA-Z0-9]{32}$/, 32, '由 32 个字符的字母与数字组成', '808钱包','808 币'],
        GB: ['GouBaopay_WD', /^[a-f0-9]{24}$/, 24, '共 24 个字符由 a-f 和 0-9 组成', '购宝钱包','G 币'],
        HI: ['HIpay_WD', /^CNYT[A-Z0-9]{16}$/, 20, '以 “CNYT” 开头，共 20 个字符由大写字母 A-Z 和 0-9 组成', '嗨钱包','CNYT 币'],
        KD: ['KDoupay_WD', /^ec[a-z0-9]{32}$/, 34, '以 “ec” 开头，为一串 34 个字母与数字组成', 'K豆钱包','K 豆'],
        JD: ['JDpay_WD', /^jd[a-z\d]{32}$/, 34, '以 "jd" 开头, 为一串 34 个小写字母与数字组成', 'JD钱包','JD 币'],
    };
    const pickFn = idx => Object.keys(conf).reduce((r,c)=>(r[c]=conf[c][idx], r), {});
    const confCoinName = pickFn(5);
    const confHardCodeName = pickFn(4);
    const confAddressHint = pickFn(3);
    const confMaxAddressLength = pickFn(2);
    const confMethodCode = pickFn(0);
    const getMethodCodeByCoinType = coinType => confMethodCode[coinType]||'';
        let ret = {
    getAvailMethodByCoinType: (availableMethods, coinType) => {
        let seek = getMethodCodeByCoinType(coinType);
        return seek ? availableMethods.find(v=>v.methodCode===seek) : {};
    },
        };
        ret.getHardCodeNameByCoinType = coinType => confHardCodeName[coinType]||'';
        ret.getNameByCoinType = (availableMethods, coinType) => {
            return ret.getAvailMethodByCoinType(availableMethods, coinType)?.methodType || '??';
        };
        ret.getCoinNameByCoinType = coinType => {
            return confCoinName[coinType]||'';
        };
        ret.getMethodCodeByCoinType = coinType => {
            return getMethodCodeByCoinType(coinType)
        };
    ret.WALLET_REGEXP_MAP = {};
    const _WALLET_REGEXP_MAP = pickFn(1)
    for (let k in _WALLET_REGEXP_MAP) {
        ret.WALLET_REGEXP_MAP[k] = {test: v => _WALLET_REGEXP_MAP[k].test(v) && /[0-9]/.test(v) && /[a-zA-Z]/.test(v) }
    }
    ret.getMaxAddressLengthByCoinType = coinType => confMaxAddressLength[coinType]||99;
    ret.getAddressHintByCoinType = coinType => confAddressHint[coinType]||'';
    ret.getKeyOfMethods = () => Object.keys(conf);

    return ret;
})();
export default DigitalcoinUtil
